import { render, staticRenderFns } from "./PairsList.vue?vue&type=template&id=1c0f81a1&"
import script from "./PairsList.vue?vue&type=script&lang=js&"
export * from "./PairsList.vue?vue&type=script&lang=js&"
import style0 from "./PairsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports